import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { imageryBgPlain } from '../../../../../assets/images'

export const GraphContentLevel2 = styled(Box)(`
    display: flex;
    flex-wrap: wrap;
    background:#fff;

    & .contentText {
        width: 100%;
        border:0;
        background: #fff;
    }
    & .contentText p {
        text-align:left;
        font-size: 12px;
        font-weight: 400;
    }
    & .titleOnlyForProgression {
        width: 100%;
        border-bottom: 1px #F3F3F3 solid;
    }
    & .pptSubHeading {display:none}
`)

export const ContentText = styled(Box)(`
    width: 100%;
    border:0;
    background: #fff;
`)

export const GraphRow = styled(Box)(`
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    min-height: 50px;
    // border-top: 2px solid #F5F5F5;
`)

export const GraphRowDetails = styled(Box)(`
    display: flex;
    width: 35px;
    justify-content: center;
    align-items: center;
    height: 30px;

    & > button {
        position: absolute;
        top: 0;
        right: 0;
        height:35px;
    }
`)

export const SliderWrapper = styled(Box)(`
    // border: 1px red solid;
`)
